import ReactDOM from 'react-dom';

import { useAuthentication } from '~/data/user/useAuthentication';
import {
  DispatchReduxFetch,
  useInitializeCommonReduxData,
} from '~/hooks/initializeData';
import { LibraryComponentProviders } from '~/library/components/LibraryComponentProviders';
import { Providers } from '~/Providers';
import { WorkflowsConfigurationView } from '~/scenes/AdminModule/components/Views/WorkflowsConfigurationView';

export const WorkflowsAdminView = () => {
  const { isAuthenticated } = useAuthentication();

  const {
    requiredStatus: { isInitializing },
  } = useInitializeCommonReduxData({
    required: [
      DispatchReduxFetch.AllEnums,
      DispatchReduxFetch.Languages,
      DispatchReduxFetch.AllOrgUnits,
    ],
  });

  if (!isAuthenticated || isInitializing) {
    return null;
  }

  return (
    <LibraryComponentProviders>
      <WorkflowsConfigurationView />
    </LibraryComponentProviders>
  );
};

export const renderWorkflowsAdminView = (containerId: string) => {
  ReactDOM.render(
    <Providers>
      <WorkflowsAdminView />
    </Providers>,
    document.getElementById(containerId),
  );
};
